import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { AccountCreationStepsAliases } from '../../codegen';

enum ValidatorsInUse {
  REQUIRED = 'required',
}

export class AccountCreationBoliviaHelper {

  static handleForeignFieldsOutFocus(currentFieldOutFocus: FieldAPI, fieldForeignId: FieldAPI, fieldForeignPassport: FieldAPI): void {
    switch (currentFieldOutFocus.getAlias()) {
      case AccountCreationStepsAliases.FIELD_FOREIGN_ID:
        AccountCreationBoliviaHelper.handleForeignIdOutFocus(fieldForeignId, fieldForeignPassport);
        break;
      case AccountCreationStepsAliases.FIELD_FOREIGN_PASSPORT:
        AccountCreationBoliviaHelper.handleForeignPassportOutFocus(fieldForeignPassport, fieldForeignId);
        break;
      default:
        break;
    }
  }

  private static handleForeignIdOutFocus(fieldForeignId: FieldAPI, fieldForeignPassport: FieldAPI): void {
    AccountCreationBoliviaHelper.addRequiredValidatorIfForeignIdExists(fieldForeignId);
    if (fieldForeignId && fieldForeignId.getValue() && fieldForeignPassport && !fieldForeignPassport.getValue()) {
      const foreignPasswordValidators = fieldForeignPassport.getValidators();
      if (foreignPasswordValidators.find(v => v.name === ValidatorsInUse.REQUIRED)) {
        fieldForeignPassport.removeValidator(ValidatorsInUse.REQUIRED);
      }
    } else if (fieldForeignId && !fieldForeignId.getValue() && fieldForeignPassport && fieldForeignPassport.getValue()) {
      fieldForeignId.removeValidator(ValidatorsInUse.REQUIRED);
    }
  }

  private static handleForeignPassportOutFocus(fieldForeignPassport: FieldAPI, fieldForeignId: FieldAPI): void {
    AccountCreationBoliviaHelper.addRequiredValidatorIfForeignPassportExists(fieldForeignPassport);
    if (fieldForeignPassport && fieldForeignPassport.getValue() && fieldForeignId && !fieldForeignId.getValue()) {
      const foreignIdValidators = fieldForeignId.getValidators();
      if (foreignIdValidators.find(v => v.name === ValidatorsInUse.REQUIRED)) {
        fieldForeignId.removeValidator(ValidatorsInUse.REQUIRED);
      }
    } else if (fieldForeignPassport && !fieldForeignPassport.getValue() && fieldForeignId && fieldForeignId.getValue()) {
      fieldForeignPassport.removeValidator(ValidatorsInUse.REQUIRED);
    }
  }

  private static addRequiredValidatorIfForeignPassportExists(fieldForeignPassport: FieldAPI): void {
    if (fieldForeignPassport && fieldForeignPassport.getValue()) {
      const foreignPassportValidators = fieldForeignPassport.getValidators();
      if (!foreignPassportValidators.find(v => v.name === ValidatorsInUse.REQUIRED)) {
        fieldForeignPassport.addValidator({ name: ValidatorsInUse.REQUIRED });
      }
    }
  }

  private static addRequiredValidatorIfForeignIdExists(fieldForeignId: FieldAPI): void {
    if (fieldForeignId && fieldForeignId.getValue()) {
      const foreignIdValidators = fieldForeignId.getValidators();
      if (!foreignIdValidators.find(v => v.name === ValidatorsInUse.REQUIRED)) {
        fieldForeignId.addValidator({ name: ValidatorsInUse.REQUIRED });
      }
    }
  }
}